var path = '/user/directives/user-details-tabs.html';
var html = "<md-card-header layout=column class=user-details-tabs> <md-tabs md-center-tabs={{!screenIsSmall}} md-tab-only=true md-no-pagination=false> <md-tab ng-repeat=\"tab in tabs\" md-active=tab.active ng-if=tab.restrictPermission|userCanFilter label={{tab.title}} data-test-id={{tab.dataTestId}} ng-click=onTabSelected(tab)></md-tab> </md-tabs> </md-card-header> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./user/directives/user-details-tabs.html
// module id = 120
// module chunks = 0